<template>
  <div class="setting-form">
    <div class="setting-form-header">
      <drawer-dialog-controls
        :is-loading="isLoading"
        @close="$emit('close')"
        @save="saveProxer"
      >
        <div class="d-flex align-center">
          <slot>
          </slot>
        </div>

        <template #export>
          <div class="d-flex flex-row align-center">
            <div class="ml-2">
              <v-btn
                icon
                @click="importSettings"
                title="Import Settings"
              >
                <v-icon>mdi-upload</v-icon>
              </v-btn>
              <v-btn
                icon
                @click="exportSettings"
                title="Export Settings"
              >
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </div>
            <export
              v-bind="exportBaseProps"
              class="card-export"
            />
          </div>

        </template>
      </drawer-dialog-controls>
    </div>
    <input
      ref="importFileInput"
      type="file"
      accept=".json"
      style="display: none"
      @change="handleFileImport"
    />
    <div class="setting-form-content">
      <v-card class="pa-4">
        <v-row class="d-flex justify-space-between align-center mx-0">
          <v-select
            v-model="settingData.entity_id"
            :items="allFormattedConfigOptions.entities"
            hide-details
            label="Project"
            style="min-width: 270px; max-width: 270px"
          />
          <div class="d-flex align-center">
            <span class="mr-2">{{ isActiveLabel(statusProject) }}</span>
            <v-switch
              :input-value="statusProject"
              @change="switchAll"
              class="mt-0 pt-0"
              hide-details
            />
          </div>
        </v-row>
        <div class="card card-content mx-0 mt-3">
          <div class="card-image">
            <img src="" />
          </div>

          <div class="card-actions">
            <div class="card-actions-wrapper">
              <export
                v-bind="exportBaseProps"
                class="card-actions-export"
              />
              <v-select
                v-model="filters.status.value"
                label="Status"
                :items="statusOptions"
                outlined
                dense
                multiple
                hide-details
                color="purple"
                style="min-width: 170px; max-width: 170px"
              >
                <template v-slot:selection="{ item, index }">
                  <span v-if="index === 0">
                    {{ item.text }}
                    <span v-if="filters.status.value.length > 1">
                      (+{{ filters.status.value.length - 1 }})
                    </span>
                  </span>
                </template>
              </v-select>
            </div>
          </div>
        </div>
        <div class="d-flex flex-column system-card mt-4">
          <v-card
            v-for="(setting, index) in filteredConfigs"
            :key="index"
            class="mx-0 px-4 pt-2 pb-4">
            <v-row class="config-choice d-flex justify-space-between mx-0">
              <div class="config-choice d-flex">
                <div>
                  <span class="font-weight-bold caption">Proxy Service:</span>
                  <v-select
                    v-model="setting.proxy_provider_id"
                    :items="allFormattedConfigOptions.proxy"
                    outlined
                    dense
                    hide-details
                    style="max-width: 200px"
                    class="mt-1 body-2"
                  ></v-select>
                </div>
                <div>
                  <span class="font-weight-bold caption">Proxy launcher country:</span>
                  <select-countries
                    :chosenCountries="setting.target_country"
                    :countries="allFormattedConfigOptions.languages"
                    :multiple="false"
                    @input="(items) => setting.target_country = items.value"
                  ></select-countries>
                  <!--                  <v-select-->
                  <!--                    v-model="setting.target_country"-->
                  <!--                    :items="allFormattedConfigOptions.languages"-->
                  <!--                    outlined-->
                  <!--                    dense-->
                  <!--                    hide-details-->
                  <!--                    style="max-width: 200px "-->
                  <!--                    class="mt-1 body-2"-->
                  <!--                  ></v-select>-->
                </div>
              </div>
            </v-row>
            <v-row class="config-choice d-flex justify-space-between mx-0 mt-4">
              <div class="config-choice d-flex">
                <div>
                  <span class="font-weight-bold caption">System:</span>
                  <custom-select
                    :value="setting.system_id"
                    @input="(item) => onInputSelectSystem(item, setting)"
                    :items="allFormattedConfigOptions.systems"
                  ></custom-select>
                </div>
                <div>
                  <span class="font-weight-bold caption">Brand:</span>
                  <custom-select
                    :value="setting.brand_id"
                    @input="(item) => onInputSelectBrand(item, setting)"
                    :items="filteredBrandsBySystem(setting)"
                    :disabled="!Boolean(setting.system_id)"
                  ></custom-select>
                </div>
                <div>
                  <span class="font-weight-bold caption">
                    Restricted countries:
                  </span>
                  <select-countries
                    :chosenCountries="setting.countries"
                    :countries="allFormattedConfigOptions.languages"
                    @input="(items) => setting.countries = items.map(({value}) => value)"
                  ></select-countries>
                </div>
              </div>
              <div class="d-flex align-center mt-5">
                <span class="mr-2">{{ isActiveLabel(setting.is_enabled) }}</span>
                <v-switch
                  v-model="setting.is_enabled"
                  class="config-switch mr-5 mt-2"
                />
                <!--                <div class="down d-flex justify-center">-->
                <!--                  <v-btn icon @click="deleteBrand(setting)">-->
                <!--                    <v-icon>mdi-delete-outline</v-icon>-->
                <!--                  </v-btn>-->
                <!--                </div>-->
              </div>
            </v-row>

            <v-card
              class="my-4 py-4 setting-form-content__body-card"
              elevation="3"
            >
              <v-row
                class="mx-0 px-4"
              >
                <div class="setting-form-content__body-title">
                  <span>Audience</span>
                </div>
              </v-row>
              <v-divider class="mt-3"></v-divider>
              <v-row class="mx-0 align-center">

                <v-combobox
                  :value="getAccountConditionIds(setting)"
                  :search-input.sync="searches[index]"
                  @change="addUserId(searches[index], setting)"
                  @click:clear="clearAllIds(setting)"
                  class="px-4 mt-4"
                  clearable
                  hide-selected
                  label="Users ID"
                  multiple
                  persistent-hint
                  small-chips
                  counter
                  style="min-width: 800px; max-width: 800px"
                  item-text="rules.value"
                  item-value="rules.value"
                  return-object
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          Press <kbd>enter</kbd> to create a new one
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                  <template v-slot:selection="{ attrs, item, select, selected }">
                    <v-chip
                      :input-value="selected"
                      close
                      v-bind="attrs"
                      @click="select"
                      @click:close="removeWithToggle(setting, item)"
                      class="audience-chip"
                    >
                      {{ item.rules?.value || item }}
                    </v-chip>
                  </template>
                </v-combobox>

                <!--                <v-btn-->
                <!--                  v-text="'Upload'"-->
                <!--                  color="primary"-->
                <!--                  @click="$refs.import.value = null, $refs.import.click()"-->
                <!--                />-->
                <!--                <input-->
                <!--                  ref="import"-->
                <!--                  type="file"-->
                <!--                  hidden-->
                <!--                  accept=".csv"-->
                <!--                  @change="onImportChange"-->
                <!--                >-->
              </v-row>
              <v-card class="ma-4 setting-form-content__body-filter" oulined>
                <div class="setting-form-content__body-filter-header">
                  <div>
                    <span>User segment filter</span>
                  </div>
                  <v-btn
                    class="setting-form-content__body-btn"
                    color="#27AE60"
                    @click="addRule(setting)"
                  >Add rules
                  </v-btn>
                </div>
                <v-card
                  v-for="(rule,idx) in segmentsGrouped[setting.accesslist_id]?.conditions"
                  :key="idx"
                  :ref="`condition-${setting.accesslist_id}-${idx}`"
                  class="ma-4 setting-form-content__body-filter filter-size"
                  oulined>
                  <v-row class="mx-0 px-10 py-8 setting-form-content__body-filter-options">
                    <v-select
                      v-model="rule.rules.field"
                      :items="SEGMENT_FIELDS"
                      class="ml-4 mt-3"
                      hide-details
                      label="Field"
                      style="min-width: 200px; max-width: 200px"
                    />
                    <v-select
                      v-model="rule.rules.equation"
                      :items="SEGMENT_EQUATION"
                      class="ml-4 mt-3"
                      hide-details
                      label="Equation"
                      style="min-width: 200px; max-width: 200px"
                    />
                    <v-text-field
                      v-model="rule.rules.value"
                      class="ml-4 mt-3"
                      hide-details
                      label="Value"
                      style="min-width: 200px; max-width: 200px"
                    />
                  </v-row>

                  <div v-if="!rule.segment_id" class="setting-form-content__body-icon" @click="deleteRule(setting, rule)">
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </div>

                  <div v-else class="setting-form-content__body-icon">
                    <v-switch
                      :input-value="rule.enabled !== false"
                      @change="toggleSegment(rule, $event)"
                      class="mt-0 pt-0"
                      hide-details
                      dense
                    />
                  </div>
                </v-card>
              </v-card>
            </v-card>

          </v-card>
        </div>
        <v-btn
          color="primary"
          outlined
          class="mt-4"
          @click="addBrand"
        >
          <v-icon>mdi-plus</v-icon>
          Add Brand
        </v-btn>
      </v-card>
    </div>
  </div>
</template>

<script>
  import DrawerDialogControls from '@/components/core/DrawerDialog/DrawerDialogControls.vue'
  import { cloneDeep, findIndex } from 'lodash'
  import { parseCSV } from '@/utils/helper'
  import { API } from '@/utils/api'
  import { filters } from '@/utils/filters'
  import CustomSelect from '@/modules/proxers/CustomSelect.vue'
  import SelectLang from '@/components/core/SelectLang/SelectLang.vue'
  import LangRow from '@/components/core/SelectLang/LangRow/LangRow.vue'
  import SelectCountries from '@/components/core/SelectCountries.vue'
  import Export from '@/components/helper/Export.vue'
  import { PROXER_EXPORT_FIELDS } from '@/modules/proxers/constants/exportFields'
  import { allCountries } from '@/components/core/SelectLang/mapperIsoLocale'

  const SKELETON_PROXER = {
    entity_id: null,
    projectTitle: '',
    status: false,
    systemBrandConfigs: [
      {
        system_id: '',
        brand_id: '',
        countries: [],
        proxy_provider_id: null,
        target_country: '',
        is_enabled: true,
        accesslist_id: null
      }
    ],
  }

  export default {
    props: {
      isLoading: {
        type: Boolean,
        default: false
      },
      proxer: {
        type: Object,
        require: true
      },
      systemList: {
        type: Array,
        require: true
      },
      brandList: {
        type: Array,
        require: true
      },
      providerList: {
        type: Array,
        require: true
      },
      entitiesMap: {
        type: Array,
        require: true
      },
      readonly: {
        type: Boolean,
        default: false
      },
      types: {
        type: Array,
        require: true
      },
    },

    components: {
      Export,
      SelectCountries,
      LangRow,
      SelectLang,
      CustomSelect,
      DrawerDialogControls,
    },
    data () {
      return {
        allCountries,
        settingData: cloneDeep(SKELETON_PROXER),
        isOpen: false,
        search: null,
        segments: [],
        searches: [],
        selectedSegments: [],
        keyExceptionCondition: 'account.id',
        exportFields: PROXER_EXPORT_FIELDS,
        tempAccessListIdCounter: 0,
        pendingSegmentChanges: [],
        statusOptions: [
          { value: true, text: 'Enabled' },
          { value: false, text: 'Disabled' },
        ],
        filters: {
          status: {
            value: [true]
          }
        },
        SEGMENT_FIELDS: [
          { value: 'deposit.count', text: 'Deposit count' },
          { value: 'deposit.amount', text: 'Deposit amount' },
          { value: 'account.type', text: 'Account type' },
          { value: 'account.country', text: 'Account country' },
          { value: 'account.language', text: 'Account language' },
          { value: 'account.currency', text: 'Account currency' },
          { value: 'account.affiliate', text: 'Affiliate' },
          { value: 'account.btag', text: 'B-Tag' },
          { value: 'account.level', text: 'VIP Level' },
          { value: 'account.unfunded', text: 'Unfunded days' }
        ],
        SEGMENT_EQUATION: [
          { value: '=', text: '=' },
          { value: '!=', text: '!=' },
          { value: '>', text: '>' },
          { value: '<', text: '<' },
          { value: '>=', text: '>=' },
          { value: '<=', text: '<=' },
          { value: 'in', text: 'in' },
          { value: 'notIn', text: 'not in' },
          { value: 'exists', text: 'exists' },
        ],
      }
    },
    async mounted () {
      await this.fetchSegmentsList()
    },
    computed: {
      statusProject () {
        return this.settingData.systemBrandConfigs.some(({ is_enabled }) => is_enabled)
      },
      isActiveLabel () {
        return (status) => status ? 'Enable' : 'Disabled'
      },
      segmentsGrouped () {
        const accessListIds = this.settingData.systemBrandConfigs.map((config) => config.accesslist_id).filter(Boolean)
        const segmentsGrouped = {}

        for (const accessListId of accessListIds) {
          segmentsGrouped[accessListId] = {
            access_list_id: accessListId,
            audience: [],
            conditions: []
          }
        }

        for (const segment of this.segments) {
          const accessListId = segment.access_list_id

          if (!accessListIds.includes(accessListId)) continue

          if (!segmentsGrouped[accessListId]) {
            segmentsGrouped[accessListId] = {
              access_list_id: accessListId,
              audience: [],
              conditions: []
            }
          }

          if (segment.rules.field === this.keyExceptionCondition) {
            segmentsGrouped[accessListId].audience.push(segment)
          } else {
            segmentsGrouped[accessListId].conditions.push(segment)
          }
        }

        return segmentsGrouped
      },
      filteredConditions () {
        return this.settingData.systemBrandConfigs.rules?.filter?.filter?.(({ field }) => field !== this.keyExceptionCondition)
      },
      accountConditionsIds () {
        let index = findIndex(this.settingData.systemBrandConfigs.rules?.filter, { field: 'account.id' })
        if (index == -1) return []
        return this.settingData.systemBrandConfigs.rules?.filter[index].value || []
      },

      uniqueBrands () {
        return Array.from(
          new Map(
            this.brandList.map(item => [ `${item.brand_id}_${item.system_id}`, item ])
          ).values()
        )
      },

      allFormattedConfigOptions () {
        const formatOptionForSelect = (list, keys = { text: 'name', value: 'value', system_id: 1, }) => {
          return list.map(item => ({
            value: item[keys.value] || item,
            text: item[keys.text] || item,
            system_id: item[keys.system_id] || item,
          }))
        }
        return {
          systems: formatOptionForSelect(this.systemList, { text: 'name', value: 'system_id' }),
          brands: formatOptionForSelect(this.uniqueBrands, { text: 'name', value: 'brand_id', system_id: 'system_id' }),
          entities: formatOptionForSelect(this.entitiesMap, { text: 'name', value: 'entity_id' }),
          languages: this.allCountries,
          proxy: formatOptionForSelect(this.providerList, { text: 'name', value: 'proxy_provider_id' })
        }
      },
      filteredBrandsBySystem () {
        return (setting) => {
          return this.allFormattedConfigOptions.brands.filter(({ system_id }) => setting.system_id ? setting.system_id === system_id : true)
        }
      },
      filterOptions () {
        return {
          'is_enabled': { data: this.filters.status.value, type: 'combobox' }
        }
      },
      filteredConfigs () {
        return filters(this.settingData.systemBrandConfigs, this.filterOptions)
      },
      exportBaseProps () {
        return {
          data: this.settingData.systemBrandConfigs.filter(item => item.is_enabled),
          fields: this.exportFields,
          project: this.settingData.entity_id,
          reportName: `${this.settingData.projectTitle} proxer settings`,
          without_sg: true
        }
      }
    },
    watch: {
      proxer: {
        handler () {
          this.settingData = this.proxer ? this.getNewSkeleton({
            ...this.proxer,
          }) : this.getNewSkeleton()
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      onInputSelectBrand (item, setting) {
        const system = this.allFormattedConfigOptions.systems.find(system => system.system_id.system_id === item.system_id)
        if (system) {
          this.$set(setting, 'system_id', system.system_id.system_id)
          this.$set(setting, 'brand_id', item.value)
        }
      },
      onInputSelectSystem (item, setting) {
        this.$set(setting, 'system_id', item.value)
        this.$set(setting, 'brand_id', '')
      },
      async fetchSegmentsList () {
        if (!this.proxer) return

        const accessListIds = this.proxer.systemBrandConfigs.map((config) => config.accesslist_id).filter(Boolean)

        const segmentsResponse = await API.call('/$v/proxer/segments/list.json', {
          entity: this.proxer?.entity_id,
          access_list_ids: accessListIds,
        })

        this.segments = segmentsResponse.data.segments || []
      },
      switchAll (flag) {
        this.settingData.systemBrandConfigs = this.settingData.systemBrandConfigs.map(config => ({ ...config, is_enabled: flag }))
      },
      getNewSkeleton (proxer) {
        const template = proxer || SKELETON_PROXER

        const skeleton = cloneDeep({
          ...template,
        })

        if (!skeleton.entity_id && this.allFormattedConfigOptions.entities.length > 0) {
          skeleton.entity_id = this.allFormattedConfigOptions.entities[0].value
        }

        skeleton.systemBrandConfigs.forEach(config => {
          if (!config.accesslist_id) {
            this.tempAccessListIdCounter++
            config.accesslist_id = `temp_${this.tempAccessListIdCounter}`
          }
        })

        return skeleton
      },

      toggleLanguages (open) {
        this.isOpen = open
      },

      getAccountConditionIds (setting) {
        const accessListId = setting.accesslist_id
        const audience = this.segmentsGrouped[accessListId]?.audience || []
        return audience.filter(seg =>
          seg.rules?.field === 'account.id' &&
          seg.enabled !== false
        )
      },
      addBrand () {
        this.tempAccessListIdCounter++
        this.settingData.systemBrandConfigs.push({
          entity_id: this.settingData.entity_id,
          system_id: '',
          brand_id: '',
          countries: [],
          proxy_provider_id: null,
          is_enabled: true,
          target_country: '',
          accesslist_id: `temp_${this.tempAccessListIdCounter}`
        })
      },

      deleteBrand (brand) {
        this.settingData.systemBrandConfigs =
          this.settingData.systemBrandConfigs.filter((config) => config != brand)
      },

      async saveProxer () {
        if (!this.validateFields()) {
          return
        }

        this.$loader.loaded = false
        try {
          const togglePromises = this.pendingSegmentChanges.map(change =>
            API.call('/$v/proxer/segments/toggle.json', change)
          )

          if (togglePromises.length > 0) {
            await Promise.all(togglePromises)
          }

          const res = await API.call('/$v/proxer/access/set.json', { proxer: this.settingData, segments: this.segments })

          this.pendingSegmentChanges = []

          this.$notification.show = true
          this.$notification.message = `Proxy update is successful`
          this.$notification.type = 'success'
          this.$emit('close')
        } catch (e) {
          this.$notification.show = true
          this.$notification.message = 'Failed to save changes'
          this.$notification.type = 'error'
        } finally {
          this.$loader.loaded = true
          this.$emit('save')
        }
      },

      validateFields () {
        const hasEmptyFields = this.settingData.systemBrandConfigs.some(config =>
          !config.system_id || config.system_id === '' ||
          !config.brand_id || config.brand_id === ''
        )

        if (hasEmptyFields) {
          this.$notification.show = true
          this.$notification.message = 'Fill in all fields'
          this.$notification.type = 'error'
          return false
        }

        return true
      },

      async removeWithToggle (setting, item) {
        const accessListId = setting.accesslist_id
        const itemValue = item.rules?.value || item

        const segmentIndex = this.segments.findIndex(seg =>
          seg.access_list_id === accessListId &&
          seg.rules?.field === 'account.id' &&
          seg.rules?.value === itemValue
        )

        if (segmentIndex !== -1) {
          const segment = this.segments[segmentIndex]

          if (segment.segment_id) {
            const existingChange = this.pendingSegmentChanges.find(change => change.segment_id === segment.segment_id)
            if (existingChange) {
              existingChange.is_enabled = false
            } else {
              this.pendingSegmentChanges.push({
                segment_id: segment.segment_id,
                entity_id: this.proxer?.entity_id || this.settingData.entity_id,
                is_enabled: false
              })
            }
          }

          this.segments.splice(segmentIndex, 1)
        }
      },

      addRule (setting) {
        const accessListId = setting.accesslist_id

        this.segments.push({
          access_list_id: accessListId,
          entity_id: this.settingData.entity_id || this.proxer?.entity_id,
          rules: {
            field: '',
            value: '',
            equation: ''
          }
        })

        this.$nextTick(() => {
          const conditions = this.segmentsGrouped[accessListId]?.conditions || []
          const lastIndex = conditions.length - 1
          const refKey = `condition-${accessListId}-${lastIndex}`
          const ref = this.$refs[refKey]

          const el = Array.isArray(ref) ? ref[0]?.$el || ref[0] : ref?.$el || ref

          if (el?.scrollIntoView) {
            el.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'nearest'
            })
          }
        })
      },

      deleteRule (setting, rule) {
        const index = this.segments.findIndex(seg => seg === rule)

        if (index !== -1) {
          this.segments.splice(index, 1)
        }
      },

      addUserId (id, setting) {
        const accessListId = setting.accesslist_id

        if (!id) return

        if (id.includes(',')) {
          const ids = id.split(',').map(value => value.trim()).filter(Boolean)
          for (const singleId of ids) {
            this.addUserId(singleId, setting)
          }
          return
        }

        const existingSegment = this.segments.find(
          (seg) => seg.access_list_id === accessListId &&
            seg.rules?.field === 'account.id' &&
            seg.rules?.value === id
        )

        if (existingSegment && existingSegment.enabled) {
          // if (existingSegment.enabled === false && existingSegment.segment_id) {
          //   this.toggleSegment(existingSegment, true)
          // }
          return
        }

        this.segments.push({
          segment_id: null,
          access_list_id: accessListId,
          entity_id: this.settingData.entity_id || this.proxer?.entity_id,
          enabled: true,
          rules: {
            field: 'account.id',
            value: id,
            equation: 'in'
          }
        })
      },

      async toggleSegment (rule, isEnabled) {
        rule.enabled = isEnabled

        if (rule.segment_id) {
          const existingChange = this.pendingSegmentChanges.find(change => change.segment_id === rule.segment_id)
          if (existingChange) {
            existingChange.is_enabled = isEnabled
          } else {
            this.pendingSegmentChanges.push({
              segment_id: rule.segment_id,
              entity_id: this.proxer?.entity_id || this.settingData.entity_id,
              is_enabled: isEnabled
            })
          }
        }
      },

      onImportChange (event) {
        if (!event.target.files.length) {
          return
        }

        const file = event.target.files[0]

        const reader = new FileReader()
        reader.readAsText(file, 'utf-8')
        reader.onload = (event) => {
          try {

            let records = parseCSV(event.target.result)

            if (!('account_id' in records[0])) {

              // this.$notification.show = true
              // this.$notification.message = 'Could not find column accound_id in results'
              // this.$notification.type = 'error'

            } else {

              for (const record of records) {
                this.addUserId(record.account_id)
              }

              // this.$notification.show = true
              // this.$notification.message = 'Successfully imported columns'
              // this.$notification.type = 'success'

            }

          } catch (err) {
            // this.$notification.show = true
            // this.$notification.message = `Failed to parse CSV, err: ${err}`
            // this.$notification.type = 'error'
          }
        }
      },
      importSettings () {
        this.$refs.importFileInput.click()
      },
      handleFileImport (event) {
        const file = event.target.files[0]
        if (!file) {
          event.target.value = ''
          return
        }

        const reader = new FileReader()
        reader.readAsText(file, 'utf-8')
        reader.onload = (e) => {
          try {
            const jsonData = JSON.parse(e.target.result)

            if (!jsonData.proxer || !jsonData.proxer.systemBrandConfigs || !Array.isArray(jsonData.proxer.systemBrandConfigs)) {
              this.$notification.show = true
              this.$notification.message = 'Format is not suitable for import'
              this.$notification.type = 'error'
              event.target.value = ''
              return
            }

            jsonData.proxer.systemBrandConfigs.forEach(config => {
              this.settingData.systemBrandConfigs.push(config)
            })

            this.settingData.systemBrandConfigs = this.settingData.systemBrandConfigs.filter(config => {
              return !(
                (!config.system_id || config.system_id === '') &&
                (!config.brand_id || config.brand_id === '') &&
                (!config.countries || config.countries.length === 0) &&
                (!config.proxy_provider_id || config.proxy_provider_id === null) &&
                (!config.target_country || config.target_country === '')
              )
            })

            if (jsonData.segments && Array.isArray(jsonData.segments)) {
              jsonData.segments.forEach(segment => {
                this.segments.push(segment)
              })
            }

            this.$notification.show = true
            this.$notification.message = 'Settings successfully imported'
            this.$notification.type = 'success'
          } catch (error) {
            this.$notification.show = true
            this.$notification.message = 'Error reading file: ' + error.message
            this.$notification.type = 'error'
          } finally {
            event.target.value = ''
          }
        }

        reader.onerror = () => {
          this.$notification.show = true
          this.$notification.message = 'Error reading file'
          this.$notification.type = 'error'
          event.target.value = ''
        }
      },

      exportSettings () {
        const accessListIdMap = new Map()
        const timestamp = Date.now()
        let tempCounter = 1

        this.proxer.systemBrandConfigs.forEach(config => {
          const oldId = config.accesslist_id
          const newId = `temp_${timestamp}_${tempCounter}`
          accessListIdMap.set(oldId, newId)
          tempCounter++
        })

        const formattedConfigs = this.proxer.systemBrandConfigs.map(config => {
          return {
            system_id: config.system_id,
            brand_id: config.brand_id,
            countries: config.countries,
            proxy_provider_id: config.proxy_provider_id,
            is_enabled: config.is_enabled,
            target_country: config.target_country,
            accesslist_id: accessListIdMap.get(config.accesslist_id)
          }
        })

        const filteredSegments = this.segments.filter(
          segment => segment.segment_id &&
                     accessListIdMap.has(segment.access_list_id)
        )

        const formattedSegments = filteredSegments.map(segment => {
          return {
            access_list_id: accessListIdMap.get(segment.access_list_id),
            rules: segment.rules
          }
        })

        const exportData = {
          proxer: {
            systemBrandConfigs: formattedConfigs
          },
          segments: formattedSegments
        }

        const jsonString = JSON.stringify(exportData, null, 2)
        const blob = new Blob([jsonString], { type: 'application/json' })
        const blobURL = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = blobURL
        link.setAttribute('download', `proxer_settings_${this.settingData.projectTitle || 'export'}_${Date.now()}.json`)

        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(blobURL)

        this.$notification.show = true
        this.$notification.message = 'Settings successfully exported'
        this.$notification.type = 'success'
      },
      async clearAllIds (setting) {
        const accessListId = setting.accesslist_id
        const audience = this.segmentsGrouped[accessListId]?.audience || []
        const accountIds = audience.filter(seg => seg.rules?.field === 'account.id')

        for (const segment of accountIds) {
          if (segment.segment_id) {
            const existingChange = this.pendingSegmentChanges.find(change => change.segment_id === segment.segment_id)
            if (existingChange) {
              existingChange.is_enabled = false
            } else {
              this.pendingSegmentChanges.push({
                segment_id: segment.segment_id,
                entity_id: this.proxer?.entity_id || this.settingData.entity_id,
                is_enabled: false
              })
            }
          }

          const segmentIndex = this.segments.findIndex(seg => seg === segment)
          if (segmentIndex !== -1) {
            this.segments.splice(segmentIndex, 1)
          }
        }
      },

    }
  }
</script>

<style lang="scss" scoped>
  .card {
    display: flex;
    justify-content: space-between;

    &-export {
      flex: none;
      margin: 0 !important;
    }

    &-actions {
      display: flex;
      align-items: flex-end;

      &-wrapper {
        display: flex;
        align-items: center;
        flex-direction: row-reverse;
      }

      &-export {
        display: flex;
        justify-content: flex-end;
        margin: 0 !important;
      }
    }

    &-image {
      flex: 0 0 18%;
      height: 140px;
      background-color: #d5d5d5;
    }
  }

  .rules-btn {
    display: flex;
    align-items: flex-end;
  }

  .config-choice {
    gap: 16px;
  }

  .system-card {
    gap: 16px;

    ::v-deep .config-switch {
      .v-input__slot {
        margin-bottom: 0;
      }
    }
  }

  .setting-form {
    background-color: #F2F2F2;
    min-height: 100vh;
    color: rgba(0, 0, 0, 87%);
    border-radius: 0 !important;

    fieldset {
      border: thin solid rgba(0, 0, 0, 0.35);
    }

    &-header {
      z-index: 100;
      position: sticky;
      top: 0;
      left: 0;
    }

    &-content {
      min-height: 100vh;
      padding: 1rem;

      &__body {
        &-icon {
          position: absolute;
          top: 16px;
          right: 16px;
        }

        &-filter {
          border: thin solid rgba(0, 0, 0, .12);
          box-shadow: none !important;

          .filter-size {
            width: 90%;
            position: relative;
          }

          &-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin: 16px;
            width: 90%;

            & span {
              font-size: 18px;
            }
          }

          &-options {
            width: 100%;
            gap: 40px;
            justify-content: space-around;

            & > div {
              margin: 0 !important;
            }
          }
        }

        &-card {
          border-left: 3px solid #4EAF50;
        }

        &-title {
          font-size: 18px;
          display: flex;
          align-items: center;
        }

        &-btn {
          color: white;
          font-size: 13px;
          height: 32px !important;
          padding: 0 !important;

          & ::v-deep .v-btn__content {
            padding: 9px 10px;
          }
        }
      }
    }
  }
</style>
